export const environment = {
    production: false,
    staging: true,
    coll: true,
    autoSaveIntervalMs: 300_000,
    testingMode: true,
    showValidationBtnErrors: false,
    apiBaseUrl: 'https://api.revisione.nodetest.it',
};
